export const resolveLegacyReturnRoute = (baseUrl) => `${baseUrl}/return/:fulfillmentId`;

export const resolveEnhancedReturnRoute = (baseUrl) => `${baseUrl}/store/:storeGuid/enhanced-return/:returnId`;
